import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';

import { ClientEvents } from '../../constants/clientEvents';

export class ValorMonster1000PerMarchHandler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.VALOR_MONSTER_1000_PER_MARCH);
    }
}
